
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { WakeupResponseBody } from '../entities/device-wake-ups-v2/wakeup-response-body';
import { WakeupRequest } from '../entities/device-wake-ups-v2';
import { axiosInstance } from "../axios-instance";

class DeviceWakeUps {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  wakeupDevices(
    input: WakeupRequest,
    bypassHeliosWakeup?: boolean
  ): Promise<AxiosResponse<WakeupRequest>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<WakeupResponseBody>(`${this.baseUrl}/wakeup`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        bypassHeliosWakeup: bypassHeliosWakeup !== undefined ? bypassHeliosWakeup : undefined,
      },
    });
  }

  requestCheckin(
    input: WakeupRequest,
    bypassHeliosWakeup?: boolean
  ): Promise<AxiosResponse<WakeupRequest>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<WakeupResponseBody>(`${this.baseUrl}/requestCheckin`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        bypassHeliosWakeup,
      }
    })
  }
}

export default DeviceWakeUps;
